import React from 'react';
import PropTypes from 'prop-types';

const PageSectionHeader = ({ section }) => {
  if (!(section.title || section.subtitle)) {
    return null;
  }

  return (
    <header className={section.align || 'left'}>
      {section.title && (
        <h2>{section.title}</h2>
      )}
      {section.subtitle && (
        <h5>{section.subtitle}</h5>
      )}
    </header>
  );
};

PageSectionHeader.propTypes = {
  section: PropTypes.object.isRequired,
};

export default PageSectionHeader;
